var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Glyphs/Edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Glyphs/Edit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "interface-essential-217",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 26 0 26 26 0 26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(3.250000, 3.250000)",
    stroke: "currentColor",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,8.66666667 L19.5,17.3333333 C19.5,18.5304167 18.5304167,19.5 17.3333333,19.5 L2.16666667,19.5 C0.969583333,19.5 0,18.5304167 0,17.3333333 L0,2.16666667 C0,0.969583333 0.969583333,0 2.16666667,0 L10.8333333,0",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1825833,3.38108333 L7.397,15.1666667 L4.33333333,15.1666667 L4.33333333,12.103 L16.1189167,0.317416667 C16.5425,-0.106166667 17.22825,-0.106166667 17.65075,0.317416667 L19.1825833,1.84925 C19.6061667,2.27283333 19.6061667,2.95858333 19.1825833,3.38108333 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.1808333,
    y1: 2.26416667,
    x2: 17.2358333,
    y2: 5.31916667,
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.27d9cfa3.svg";
export { ForwardRef as ReactComponent };